import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_AMENITY = createActionTypes('FETCH_AMENITY');
export const GET_AMENITY = createActionTypes('GET_AMENITY');
export const CREATE_AMENITY = createActionTypes('CREATE_AMENITY');
export const UPDATE_AMENITY = createActionTypes('UPDATE_AMENITY');
export const DELETE_AMENITY = createActionTypes('DELETE_AMENITY');
